import type { SimpleContainer } from '@wix/ambassador-devcenter-v1-component-type-data/types';
import { ResizeDirection } from '@wix/ambassador-devcenter-v1-component-type-data/types';

export const MENU_ITEMS_DEFAULT_SIMPLE_CONTAINER: SimpleContainer = {
  layout: { resizeDirection: ResizeDirection.vertical },
  behaviors: { selectable: true },
};
